import { render } from "./SentData.vue?vue&type=template&id=5d222996&ts=true"
import script from "./SentData.vue?vue&type=script&lang=ts"
export * from "./SentData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__